<script lang="ts" setup>
import type { ComponentSectionsMultiAccordion, GetTransportsQuery } from '@autobid/strapi-integration/graphql/graphql'

interface Props {
  transports: GetTransportsQuery['transportCountries']
}

const props = defineProps<Props>()

type Emails = NonNullable<
  NonNullable<
    GetTransportsQuery['transportCountries'][number]
  >['companies'][number]
>['emails']

function parseTransportsToAccordionData(): ComponentSectionsMultiAccordion {
  const homepageLinkTemplate = (link?: string | null) =>
    link?.length
      ? `<a href="${link}" target="_blank" rel="nofollow noopener noindex">${link}</a>`
      : ''

  const emailsTemplate = (emails: Emails) => {
    if (emails == null || !emails.length) {
      return ''
    }

    let html = ''

    for (const email of emails) {
      if (!email) {
        continue
      }

      html += `<li class="m-0"><a href="mailto:${email.email}">${email.email}</a></li>`
    }

    return `<ul class="mt-2">${html}</ul>`
  }

  return {
    id: Math.random().toString(36).substring(2, 9),
    __typename: 'ComponentSectionsMultiAccordion',
    accordions: props.transports.filter(transport => !!transport).map(
      (transport) => {
        return {
          id: transport.documentId,
          title: transport.name,
          items: transport.companies.filter(company => !!company).map((company) => {
            return {
              id: company.documentId,
              title: company.name,
              description: `
                ${homepageLinkTemplate(company.homepage)}
                ${emailsTemplate(company.emails)}
              `,
            }
          }),
          alwaysOpen: false,
        }
      },
    ),
    alwaysOpen: false,
  }
}
const accordionData = parseTransportsToAccordionData()
</script>

<template>
  <SectionsMultiAccordion :data="accordionData" />
</template>
